import React from 'react'
import type { PainterWorkAreaSummary } from './types'
import WorkAreaSummaryTotal from './WorkAreaSummaryTotal'
import type { usePainterWorkOrderStyles } from './usePainterWorkOrderStyles'

interface WorkAreaSummaryGridProps {
  areas: PainterWorkAreaSummary
  classes: ReturnType<typeof usePainterWorkOrderStyles>
}

export default function WorkAreaSummaryGrid({ areas, classes }: WorkAreaSummaryGridProps) {
  const hasLeft = areas.walls != null || areas.floor != null
  return (
    <div className={classes.workAreaGrid}>
      <div className={classes.workAreaRow}>
        {hasLeft && (
          <div className={classes.workAreaCellColumn}>
            {areas.walls != null && (
              <div className={classes.workAreaCellRow}>
                <span className={classes.workAreaCellLabel}>Walls:</span>
                <span className={classes.workAreaCellValue}>{areas.walls.toLocaleString()} sqft</span>
              </div>
            )}
            {areas.floor != null && (
              <div className={classes.workAreaCellRow}>
                <span className={classes.workAreaCellLabel}>Floor:</span>
                <span className={classes.workAreaCellValue}>{areas.floor.toLocaleString()} sqft</span>
              </div>
            )}
          </div>
        )}
        {areas.ceilings != null && (
          <div className={classes.workAreaCell}>
            <span className={classes.workAreaCellLabel}>Ceilings:</span>
            <span className={classes.workAreaCellValue}>{areas.ceilings.toLocaleString()} sqft</span>
          </div>
        )}
      </div>
      <div className={classes.workAreaTotals}>
        {areas.totalSqft != null && (
          <WorkAreaSummaryTotal label="Total sqft:" value={areas.totalSqft.toLocaleString()} classes={classes} />
        )}
        {areas.totalLnft != null && (
          <WorkAreaSummaryTotal label="Total lnft:" value={areas.totalLnft} classes={classes} />
        )}
      </div>
    </div>
  )
}
